import React, { Component } from 'react'
import { Link } from 'react-router'
import style from './style.module.less'

export default class extends Component {
  render() {
    return (
      <div className={style.intro}>
        温馨提示：
        <ul>
          <li>订单完成支付 1 天后才可以索取发票。</li>
          <li>发票基于订单开具，即单个订单不可拆分开票。</li>
          <li>
            2018.03.01
            以后购买成功的订单，可以在线索取发票，在此之前购买的订单请采取原方式索取发票，谢谢。
          </li>
        </ul>
        <Link
          to="localMerchant/marketingCenter/billingQuestion"
          className={style.link}
        >
          发票常见问题>
        </Link>
      </div>
    )
  }
}
